export type LatLng = {
  lat: any;
  lng: any;
};

export type MapProps = {
  defaultCenter?: LatLng;
  zoom?: number;
  mapTypeId?: MapType;
  disableDefaultUI?: boolean;
  mapTypeControl?: boolean;
  scaleControl?: boolean;
  zoomControl?: boolean;
  streetViewControl?: boolean;
  fullscreenControl?: boolean;
  className?: string;
  bounds?: any;
  waypoints?: any;
  isMyload: any;
  isLimitedZoom?: boolean;
};

export type MapState = {
  isMapReady: boolean;
  map: any;
  google: any;
  directionsService: any;
  directionsRenderer: any;
};

export enum MapType {
  roadmap = "roadmap",
  satellite = "satellite",
  hybrid = "hybrid",
  terrain = "terrain",
}

export type MarkerProps = {
  position: LatLng | string;
  title?: string;
  icon?: string;
};

export type InfoWindowProps = {
  content?: string;
  pixelOffset?: string;
  position?: LatLng;
  maxWidth?: string;
  title?: string;
};

export enum TravelMode {
  DRIVING = "DRIVING",
  BICYCLING = "BICYCLING",
  TRANSIT = "TRANSIT",
  WALKING = "WALKING",
}

export enum UnitSystem {
  METRIC = "METRIC",
  IMPERIAL = "IMPERIAL",
}

export type DirectionLocation = {
  locationName: LatLng | string | any;
  locationType: string;
  index: number;
  isMarkerAdded: boolean;
  latLng: LatLng;
  postalCode: any;
  city: string,
  state: string
  shipmentId?: any;
  stopId: string;
  addressLine1?: any;
};

export type DirectionsWaypoint = {
  location: DirectionLocation;
  stopover?: boolean;
};

export type DirectionsRequest = {
  origin: DirectionLocation;
  destination: DirectionLocation;
  travelMode?: TravelMode;
  unitSystem?: UnitSystem;
  waypoints?: DirectionsWaypoint[];
  optimizeWaypoints?: boolean;
  zoomLevel?: any;
  directionRenderCallback: () => void;
  isShowAddrInfoWindow: boolean;
  isMyload: boolean;
};

export type ShapeProps = {
  strokeColor?: string;
  strokeOpacity?: number;
  strokeWeight?: number;
  fillColor?: string;
  fillOpacity?: number;
};

export type CircleProps = {
  center: LatLng;
  radius: number;
} & ShapeProps;

export type PolylineOptions = {
  path: LatLng[];
} & ShapeProps;

export type PolygonOptions = {
  paths: LatLng[];
} & ShapeProps;

export type RectangleOptions = {
  bounds: {
    north: number;
    south: number;
    east: number;
    west: number;
  };
} & ShapeProps;

export enum ControlPosition {
  TOP_CENTER = "TOP_CENTER",
  TOP_LEFT = "TOP_LEFT",
  TOP_RIGHT = "TOP_RIGHT",
  LEFT_TOP = "LEFT_TOP",
  RIGHT_TOP = "RIGHT_TOP",
  LEFT_CENTER = "LEFT_CENTER",
  RIGHT_CENTER = "RIGHT_CENTER",
  LEFT_BOTTOM = "LEFT_BOTTOM",
  RIGHT_BOTTOM = "RIGHT_BOTTOM",
  BOTTOM_CENTER = "BOTTOM_CENTER",
  BOTTOM_LEFT = "BOTTOM_LEFT",
  BOTTOM_RIGHT = "BOTTOM_RIGHT",
}

export type CustomControlProps = {
  text: string;
  controlPosition: ControlPosition;
  iconName?: string;
  onClick?: () => void;
};